// extracted by mini-css-extract-plugin
module.exports = {"legend":"Legend-module__legend--2jXQz","marker":"Legend-module__marker--2SYLL","tooltip":"Legend-module__tooltip--gi746"};